@if (isLoading()) {
  <div class="loader">
    <rds-progress-spinner></rds-progress-spinner>
  </div>
}
<rds-header minimalMargins>
  <rds-divider rds-header-start-divider class="native-menu"></rds-divider>
  <rds-header-app-name routerLink="/dashboard/rooms">
    <img
      class="header-logo"
      ngSrc="assets/bookly-logo.svg"
      width="116"
      height="32"
      alt="bookly-logo" />
  </rds-header-app-name>
  <rds-divider rds-header-end-divider class="native-menu"></rds-divider>\
  <rds-header-navigation-primary>
    <div class="native-menu">
      <div class="flex-row">
        <rds-header-link
          [routerLink]="'/dashboard/rooms'"
          routerLinkActive="rds-link--active">
          Explore Rooms
        </rds-header-link>
        <rds-header-link
          [routerLink]="'/dashboard/rooms'"
          [queryParams]="{ calendarView: true }"
          routerLinkActive="rds-link--active">
          Multi Space View
        </rds-header-link>
        <rds-header-link
          [routerLink]="'/dashboard/bookings'"
          routerLinkActive="rds-link--active">
          My Bookings
        </rds-header-link>
        <rds-header-link
          *bshHasAccess="RoleType.ADMIN"
          [routerLink]="RoleType.ADMIN | roleRoute"
          routerLinkActive="rds-link--active">
          Admin Panel
        </rds-header-link>
        <rds-header-link
          *bshHasAccess="RoleType.ROOM_HOST"
          [routerLink]="RoleType.ROOM_HOST | roleRoute"
          routerLinkActive="rds-link--active">
          Room Host Panel
        </rds-header-link>
        <rds-header-link
          *bshHasAccess="RoleType.SERVICE_PROVIDER"
          [routerLink]="RoleType.SERVICE_PROVIDER | roleRoute"
          routerLinkActive="rds-link--active">
          Service Provider Panel
        </rds-header-link>
      </div>
    </div>
  </rds-header-navigation-primary>

  <rds-header-actions>
    <div class="native-menu">
      <rds-header-navigation-primary>
        <rds-header-link (toggle)="navigateToHelpCenter()">
          Help
          <rds-icon
            class="external-link-icon"
            namespace="outlined"
            icon="external_link" />
        </rds-header-link>
        <rds-header-link (toggle)="navigateToFeedback()">
          <rds-custom-icon icon="bulb" class="feedback-icon"></rds-custom-icon>
        </rds-header-link>
      </rds-header-navigation-primary>
    </div>
    <div class="striped-divider">
      <rds-divider vertical class="native-menu striped-divider"></rds-divider>
    </div>
    <bus-favorite-indicator></bus-favorite-indicator>
    <bsh-notifications-dropdown></bsh-notifications-dropdown>
    @if (user) {
      <div
        rdsDropdown
        #desktopDropdown
        [autoClose]="true"
        placement="bottom-right"
        class="native-menu">
        <rds-avatar class="dropdown-toggle" rdsDropdownToggle trigger="click">
          @if (user.picture) {
            <img
              rds-avatar-image
              [ngSrc]="user.picture"
              fill
              alt="User avatar"
              referrerpolicy="no-referrer" />
          } @else {
            <rds-icon rds-avatar-icon namespace="outlined" icon="user" />
          }
        </rds-avatar>
        <div class="dropdown" *rdsDropdownMenu>
          <span class="dropdown__name">
            {{ user.name }}
          </span>
          <span class="dropdown__email">{{ user.email }}</span>
          <button rds-text-button (click)="logout()">Logout</button>
        </div>
      </div>
    }
    <div
      class="mobile-menu"
      rdsDropdown
      #mobileDropdown
      [autoClose]="true"
      placement="bottom-center">
      <div class="buttons-container">
        <button
          rds-icon-button
          size="m"
          (click)="filterMenu.showMenu()"
          [ngStyle]="
            showFiltersMenu() ? { display: 'initial' } : { display: 'none' }
          ">
          <rds-icon namespace="filled" icon="filter"></rds-icon>
        </button>
        <button
          rds-icon-button
          size="m"
          (click)="chartFilterMenu.showMenu()"
          [ngStyle]="
            showChartsMenu() ? { display: 'initial' } : { display: 'none' }
          ">
          <rds-icon namespace="filled" icon="filter"></rds-icon>
        </button>
        <button
          rdsDropdownToggle
          trigger="click"
          rds-dropdown-toggle-icon-button
          size="m">
          <rds-icon namespace="filled" icon="menu"></rds-icon>
        </button>
      </div>
      <div *rdsDropdownMenu class="hamburger-content">
        <rds-header-link
          [routerLink]="'/dashboard/rooms'"
          routerLinkActive="rds-link--active">
          Explore Rooms
        </rds-header-link>
        <rds-header-link
          [routerLink]="'/dashboard/rooms'"
          [queryParams]="{ calendarView: true }"
          routerLinkActive="rds-link--active">
          Multi Space View
        </rds-header-link>
        <rds-header-link
          [routerLink]="'/dashboard/bookings'"
          routerLinkActive="rds-link--active">
          My Bookings
        </rds-header-link>
        <rds-header-link
          *bshHasAccess="RoleType.ADMIN"
          [routerLink]="RoleType.ADMIN | roleRoute"
          routerLinkActive="rds-link--active">
          Admin Panel
        </rds-header-link>
        <rds-header-link
          *bshHasAccess="RoleType.ROOM_HOST"
          [routerLink]="RoleType.ROOM_HOST | roleRoute"
          routerLinkActive="rds-link--active">
          Room Host Panel
        </rds-header-link>
        <rds-header-link
          *bshHasAccess="RoleType.SERVICE_PROVIDER"
          [routerLink]="RoleType.SERVICE_PROVIDER | roleRoute"
          routerLinkActive="rds-link--active">
          Service Provider Panel
        </rds-header-link>
        <rds-header-link (toggle)="navigateToFeedback()">
          Feedback
          <rds-icon
            class="external-link-icon"
            namespace="outlined"
            icon="external_link" />
        </rds-header-link>
        <rds-header-link (toggle)="navigateToHelpCenter()">
          Help
          <rds-icon
            class="external-link-icon"
            namespace="outlined"
            icon="external_link" />
        </rds-header-link>
        @if (user) {
          <rds-divider></rds-divider>
          <div class="user-data">
            <span class="user-data__name">
              {{ user.name }}
            </span>
            <span class="user-data__email">{{ user.email }}</span>
            <button rds-secondary-button size="s" (click)="logout()">
              <rds-icon icon="power_standby" namespace="filled" />
              Logout
            </button>
          </div>
        }
      </div>
    </div>
  </rds-header-actions>
</rds-header>
<div class="main-panel">
  <bus-room-filters-menu
    #filterMenu
    [ngStyle]="
      showFiltersMenu() ? { display: 'initial' } : { display: 'none' }
    "></bus-room-filters-menu>
  <bsh-chart-filter-menu
    #chartFilterMenu
    [ngStyle]="
      showChartsMenu() ? { display: 'initial' } : { display: 'none' }
    "></bsh-chart-filter-menu>
  <main>
    <router-outlet></router-outlet>
  </main>
</div>
